import { useMemo, useState } from 'react';
import { addMonths, eachDayOfInterval, endOfMonth, endOfWeek, startOfMonth, startOfWeek, subMonths } from 'date-fns';

export interface DateIntervalFromMonth {
  interval: Date[];
  incDecMonth(inc: boolean): void;
  start: Date;
  end: Date;
}

const useDateIntervalFromMonth = (
  date: Date,
  includeWeeks = true,
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 1
): DateIntervalFromMonth => {
  const [selectedMonth, setSelectedMonth] = useState(startOfMonth(date));
  const startAndEnd = useMemo(
    () => ({
      start: includeWeeks ? startOfWeek(startOfMonth(selectedMonth), { weekStartsOn }) : selectedMonth,
      end: includeWeeks ? endOfWeek(endOfMonth(selectedMonth), { weekStartsOn }) : endOfMonth(selectedMonth)
    }),
    [selectedMonth, weekStartsOn, includeWeeks]
  );
  const interval = useMemo(() => eachDayOfInterval(startAndEnd), [startAndEnd]);

  const incDecMonth = (inc: boolean): void => {
    setSelectedMonth((m) => (inc ? addMonths(m, 1) : subMonths(m, 1)));
  };

  return {
    interval,
    incDecMonth,
    start: startAndEnd.start,
    end: startAndEnd.end
  };
};

export default useDateIntervalFromMonth;
